<template>
  <div>
     <va-modal
        v-model="showModalRemove"
        size="small"
        :title="$t('modal.remove')"
        :message="$t('modal.messageRemoveDailyOperation')"
        hideDefaultActions
        :color="this.$themes.secondary"
      >

      <va-button
        color="secondary"
        class="ma-2"
        @click="showModalRemove = false">
        {{$t('modal.cancel')}}
      </va-button>

      <va-button
        color="green"
        class="ma-2"
        @click="remove(daily_operation_to_remove), showModalRemove = false">
        {{$t('modal.confirm')}}
      </va-button>
    </va-modal>

     <va-card :title="$t('menu.operation_of_day')">
       <div class="flex xs12 sm3">
          <va-date-picker
            :label="$t('tables.date')"
            v-model="date"
          />
      </div>

      <div class="flex xs12 sm3">
        <va-button
          v-if="!edit"
          medium
          inline
          color="secondary"
          icon="fa fa-plus"
          class="ma-0"
          @click="newDailyOperation"
        >
          {{ $t('menu.new') }}
        </va-button>
      </div>

      <form ref="form" @submit.prevent v-if="edit">
        <div class="row">
          <div class="flex md3 sm3 xs12">
            <va-input type="datetime-local" v-model="daily_operation.start_of_operation" :label="$t('tables.operation.start_of_operation')"/>
          </div>
          <div class="flex md3 sm3 xs12">
            <va-input type="datetime-local" v-model="daily_operation.start_of_interval" :label="$t('tables.operation.start_of_interval')" removable/>
          </div>

          <div class="flex md3 sm3 xs12">
            <va-input type="datetime-local" v-model="daily_operation.end_of_interval" :label="$t('tables.operation.end_of_interval')" removable/>
          </div>

           <div class="flex md3 sm3 xs12">
             <va-input type="datetime-local" v-model="daily_operation.end_of_operation" :label="$t('tables.operation.end_of_operation')" removable/>
          </div>

        </div>
        <va-button
          medium
          inline
          color="secondary"
          icon="fa fa-save"
          class="ma-0"
          @click="saveDailyOperation()"
        > {{ $t('menu.save') }} </va-button>

        <va-button
          medium
          inline
          color="#ff842b"
          icon="fa fa-chevron-left"
          @click="goBack()"
        > {{ $t('menu.back') }} </va-button>
      </form>

      <br>
      <va-data-table
        v-if="!edit"
        :fields="fields"
        :data="daily_operations"
        :per-page="10">

        <template slot="start_of_operation" slot-scope="item">
          {{ item.rowData.start_of_operation | prettyDate }}
        </template>

        <template slot="start_of_interval" slot-scope="item">
          {{ item.rowData.start_of_interval | prettyDate }}
        </template>

         <template slot="end_of_interval" slot-scope="item">
          {{ item.rowData.end_of_interval | prettyDate }}
        </template>

        <template slot="end_of_operation" slot-scope="item">
          {{ item.rowData.end_of_operation | prettyDate }}
        </template>

        <template slot="elapsed_time" slot-scope="item">
          {{ elapsedTime(item.rowData, now) }}
        </template>

        <template slot="actions" slot-scope="item">
          <va-button
              small
              inline
              color="green"
              icon="fa fa-edit"
              class="mr-1"
              @click="editDailyOperation(item.rowData.id)"
            >
              {{ $t('menu.edit') }}
          </va-button>

           <va-button
            small 
            inline 
            color="danger" 
            icon="fa fa-remove"
            class="ma-0"
            @click="showModalRemove = true, daily_operation_to_remove = item.rowData.id" 
          >
            {{ $t('tables.delete') }}
          </va-button>
        </template>
    </va-data-table>
      
    </va-card>
  </div>
</template>

<script>

import { mapState } from "vuex";
import { http } from "@/services/config";
import { showError } from '@/global';
import moment from 'moment';
import { DailyOperationMenu } from '../admin/app-sidebar/sub-menus/DailyOperationMenu';
import DailyOperationAPI from '@/services/DailyOperationAPI'

export default {
  data () {
    return {
      edit: false,
      today_operation : "",
      date_today: moment().format("DD/MM/YYYY"),
      date: "",
      now: new moment(),
      daily_operations: [],
      daily_operation: {
        start_of_operation: "",
        start_of_interval: "",
        end_of_interval: "",
        end_of_operation: "",
        locality_id: "",
      },
      daily_operation_to_remove: "",
      showModalRemove: false,
      now: new moment(),
      interval: '',
      
    }
  },

  filters: {
    prettyDate (value) {
      if (value !== undefined && value !== null && value !== "") {
        return moment.parseZone(value).format("DD/MM/YYYY HH:mm")
      } else {
        return value
      }
    }
  },


  mounted () {
    this.date = new Date();
    let dateNow = moment(new Date).format('DD/MM/YYYY');

    this.getDailyOperations(dateNow, this.currentLocality.id)

    this.interval = setInterval(() => { this.now = new moment() }, 1000)
  },

  beforeDestroy () {
    window.clearInterval(this.interval)
  },

  computed: {
    ...mapState(['rules', 'currentLocality', 'currentUser']),

    fields () {
      return [
        { name: "id", title: "ID" },
        { name: "operation_sequence", title: this.$t('tables.operation.sequence') },
        { name: "__slot:start_of_operation", title: this.$t('tables.operation.start_of_operation')},
        { name: "__slot:start_of_interval", title: this.$t('tables.operation.start_of_interval')},
        { name: "__slot:end_of_interval", title: this.$t('tables.operation.end_of_interval')},
        { name: "__slot:end_of_operation", title: this.$t('tables.operation.end_of_operation')},
        { name: "__slot:elapsed_time", title: this.$t('tables.operation.duration')},
        { name: "__slot:actions" }
      ]
    }
  },

  watch: {
    date: function(newDate) {
      let dateFormated = moment.parseZone(newDate).format('DD/MM/YYYY')

      this.getDailyOperations(dateFormated, this.currentLocality.id)
    },

    '$store.state.currentLocality': function() {
      this.getDailyOperations(this.date, this.currentLocality.id)
    }
  },

  methods: {
    goBack () {
      this.edit = false
    },

    elapsedTime: function (operation, now) {
      var start_of_operation = moment(operation.start_of_operation)

      if (operation.start_of_interval != null && operation.end_of_interval != null){
        var start_of_interval = moment(operation.start_of_interval)
        var end_of_interval = moment(operation.end_of_interval)
        var interval_diff = end_of_interval.diff(start_of_interval)
      } else {
        var interval_diff = 0
      }
      
      if (operation.end_of_operation === null){
        var duration = moment.duration(now.diff(start_of_operation) - interval_diff)
      } else {
        var end_of_operation = moment(operation.end_of_operation)
        var duration = moment.duration(end_of_operation.diff(start_of_operation) - interval_diff)
      }
      
      var hours_with_days = duration._data.hours

      if(duration._data.days > 0){
        var hours_with_days = duration._data.hours + (duration._data.days * 24)
      }

      var hours = hours_with_days === 1 ? `${hours_with_days} ${this.$t('tables.workTime.hour')}` : `${hours_with_days} ${this.$t('tables.workTime.hours')}`
      var minutes = duration._data.minutes === 1 ? `${duration._data.minutes} ${this.$t('tables.workTime.minute')}` : `${duration._data.minutes} ${this.$t('tables.workTime.minutes')}`

      if (duration._data.hours > 0){
        return `${hours} ${this.$t('tables.workTime.and')} ${minutes}`
      } else {
        return `${this.$t('tables.workTime.and')} ${minutes}`
      } 
    },

    newDailyOperation () {
      this.daily_operation = {}

      let now = moment()
      var datetime = moment(this.date)

      datetime.set('hour', now.format('HH'))
      datetime.set('minutes', now.format('mm'))

      this.daily_operation.start_of_operation = datetime.format('YYYY-MM-DDTHH:mm');
      this.daily_operation.locality_id = this.currentLocality.id
      this.edit = true
    },

    async editDailyOperation (id) {
      DailyOperationAPI.getDailyOperationsById(id).then(response =>{
        this.daily_operation = response.data.daily_operation
      }).catch(e => {
        this.showToast(e.response.data.error, {
          icon: 'fa-thumbs-o-down',
          position: 'top-right',
          duration: 5000,
        })
      })
      this.edit = true
    },

    async saveDailyOperation () {
      if (this.daily_operation.id ) {
        DailyOperationAPI.updateDailyOperation(this.daily_operation).then(()=>{
          this.edit = false
          this.getDailyOperations(this.daily_operation.start_of_operation, this.currentLocality.id);
        }).catch(e => {
          this.edit = false
          this.getDailyOperations(this.daily_operation.start_of_operation, this.currentLocality.id);
          this.showToast(e.response.data.error, {
            icon: 'fa-thumbs-o-down',
            position: 'top-right',
            duration: 5000,
          })
        })
      } else {
        DailyOperationAPI.createDailyOperation(this.daily_operation).then(()=>{
          this.edit = false
          this.getDailyOperations(this.daily_operation.start_of_operation, this.currentLocality.id);
        }).catch(e => {
          this.edit = false
          this.getDailyOperations(this.daily_operation.start_of_operation, this.currentLocality.id);
          this.showToast(e.response.data.error, {
            icon: 'fa-thumbs-o-down',
            position: 'top-right',
            duration: 5000,
          })
        })
      }
    },

    async getDailyOperations (date, localityID) {
      DailyOperationAPI.getDailyOperations(date, localityID).then(response => {
        this.daily_operations = response.data.daily_operations
      }).catch(e => {
        this.showToast(e.response.data.error, {
          icon: 'fa-thumbs-o-down',
          position: 'top-right',
          duration: 5000,
        })
      })
    },

    async remove (daily_operation_id) {
      DailyOperationAPI.removeDailyOperation(daily_operation_id).then(() => {
        this.getDailyOperations(this.date, this.currentLocality.id)
      }).catch(e => {
        this.showToast(e.response.data.error, {
          icon: 'fa-thumbs-o-down',
          position: 'top-right',
          duration: 5000,
        })
      })
    },
  },
}
</script>

<style>

</style>
